import { Component, OnInit, OnDestroy, NgZone, Inject, PLATFORM_ID, Input } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// service
import { LoginService } from '../../services/login.service';
import { SharedService } from '../../services/shared-service.service';
import { CopyService } from '../../../shared/services/app-copy.service';

// models
import { AppState } from '../../../booking/models/app-state.interface';

declare var zE: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Input() componentRender: string = '';

  private _routeSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _userSubscription: Subscription;
  private _userLanguageSubscription: Subscription;

  private _initLoad = true;

  public currentPartner = null;
  public brandingPartner = null;
  public user;
  public price;
  public currentRoute = '';
  public showOverview = false;
  public bookingInit: Boolean = false;
  public priceInit: Boolean = false;
  public userLoggedIn: Boolean = false;
  public dropdownToggle: Boolean = false;
  public partnerLoaded = false;
  public bookingState;
  public bookingType = '';
  public selectedLanguage: string = '';
  public availableLaguage: string[] = ['en', 'fr', 'de'];
  public appCopy;
  public copyLoaded: Boolean = false;
  public isErrorScreen: boolean = false;
  public isUpsellScreen: boolean = false;
  public isBookingScreen: boolean = false;
  public isFlyback: boolean = false;

  constructor(
    private _appStore: Store<AppState>,
    private _router: Router,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _sharedService: SharedService,
    private _copyService: CopyService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {

      this.isBookingScreen = ['flight-finder', 'abc', 'ccd', 'fly-back-details', 'complete'].includes(window.location.pathname.split('/')[1]);
      this._userSubscription = this._appStore.select('userReducer')
        .subscribe((user: any) => {
          this._ngZone.run(() => {
            this.user = user.userDetails;
            this.userLoggedIn = user.userDetails.userLoggedIn;
          });
        });

      this._routeSubscription = this._router.events.subscribe(event => {
        console.log('routing', event);

        if (event instanceof NavigationEnd) {
          this.isErrorScreen = event.url === '/error-404' || event.url === '/error-500' || event.urlAfterRedirects === '/error-404';
          this.isUpsellScreen = event.url === '/redirectingTo';
          this.isBookingScreen = event.url.includes('abc') || event.url.includes('ccd') || event.url.includes('flight-finder') || event.url.includes('complete') || event.url.includes('fly-back-details');
        }

      });

      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.bookingInit = res.currentBookingLoaded;
          this.copyLoaded = res.copyLoaded;

          if (res.partnerLoaded && this._initLoad) {

            if (this.getState(this._appStore).partnerReducer.partnerName === 'NONE') {
              this.brandingPartner = 'airportr';
            } else {
              this.brandingPartner = this.getState(this._appStore).partnerReducer.partnerName.toLocaleLowerCase();
            }

            this.partnerLoaded = true;
            this._initLoad = false;
          }

          if (res.copyLoaded) {
            this.getCopy();
          }

          this._userLanguageSubscription = this._appStore.select('copyReducer')
            .subscribe((res: any) => {
              this.selectedLanguage = res.language
            })

        });

    }
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'loggedInHeader',
      ['panelHeader']
    );
    console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  // goToLogin() {
  //   this._router.navigate(['login']);
  // }

  // goToRegister() {
  //   this._router.navigate(['register']);
  // }

  // goToMyAccount() {
  // this._appStore.dispatch({ type: 'UPDATE_PARTNER_NAME', payload: { partnerName: 'NONE' } });
  // this._router.routeReuseStrategy.shouldReuseRoute = function(){return false; };
  // const currentUrl = this._router.url + '?';
  // this._router.navigateByUrl(currentUrl)
  //   .then(() => {
  //     this._router.navigated = false;
  //     window.open('my-account/home', '_self');
  //   });
  // }

  logout() {
    this.dropdownToggle = false;
    this._loginService.logout();
  }
  handleChatClick() {
    zE.activate({ hideOnClose: true });
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {

    if (isPlatformBrowser(this.platformId)) {
      this._bookingInitSubscription.unsubscribe();
      if (this.bookingInit) {
        this._userSubscription.unsubscribe();
      }
      if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe() }
    }
  }

}
